import { inject, Injectable } from '@angular/core';
import { GoogleAnalyticsService } from '../../google-analytics.service';

@Injectable({providedIn: 'root'})
export class AnalyticsHeaderService {

    gAnalytics = inject(GoogleAnalyticsService)


    trackNotificationClick() {
        this.gAnalytics.trackEvent('notificacion_clickeada', {
            page:'/',
            action: 'Notificación clickeada en el header'
        })
    }

    
}